import React from "react";

const CarCounts = ({ row }) => {
  return (
    <div>
      {row.payments.map((item, index) => (
        <div>{item.carCount}</div>
      ))}
    </div>
  );
};

export default CarCounts;
